/* External dependencies */
import update from 'react-addons-update';

/* Local dependencies */
import { AuthModalActions, AuthModalActionsTypes } from './actions';

interface AuthModalReducerTypes {
  currentModal: string | null;
  isToggled: boolean;
  entryType: string | null;
}

const initialAuthModalState: AuthModalReducerTypes = {
  currentModal: null,
  isToggled: false,
  entryType: null,
};

export function authModalReducer(state = initialAuthModalState, action: AuthModalActions): AuthModalReducerTypes {
  switch (action.type) {
    case AuthModalActionsTypes.GO_NEXT:
      return update(state, {
        currentModal: { $set: action.currentModal },
      });

    case AuthModalActionsTypes.GO_BACK:
      return update(state, {
        currentModal: { $set: action.previousModal },
      });

    case AuthModalActionsTypes.CLOSE_MODAL:
      return update(state, {
        currentModal: { $set: null },
      });

    case AuthModalActionsTypes.TOGGLE_THEME:
      return update(state, {
        isToggled: { $set: !state.isToggled },
      });

    case AuthModalActionsTypes.ENTRY_TYPE:
      return update(state, {
        entryType: { $set: action.entryType },
      });

    default:
      return state;
  }
}
